export default __webpack_public_path__ + "static/CorprateHp_09-d0e5a4b67051ff417b7fd89d9690d43d.jpg";